export const APP_VERSION_MANIFEST_PATH = '/version.json';

export const APP_VERSION_POLL_INTERVAL_MS = 60 * 1000;

export const CHUNK_RELOAD_SESSION_KEY = 'mpa_chunk_reload_once';

export const APP_VERSION_NOTIFICATION_ID = 'app-version-update';
